import React, { Component, useEffect, useState } from 'react';
import { Menu, Dropdown, Badge, Avatar, List, Button } from 'antd';
import { 
  MailOutlined, 
  BellOutlined, 
  WarningOutlined,
  CheckCircleOutlined
} from '@ant-design/icons';
import notificationData from "assets/data/notification.data.json";
import Flex from 'components/shared-components/Flex'
import { connect } from 'react-redux';
import { getNotifications, checkNotification, checkAllNotifications } from 'redux/actions/Notification';
import { EyeOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';

const moment = require('moment');
const getIcon =  icon => {
  switch (icon) {
    case 'mail':
      return <MailOutlined />;
    case 'alert':
      return <WarningOutlined />;
    case 'check':
      return <CheckCircleOutlined />
    default:
      return <MailOutlined />;
  }
}

export class NavNotification extends Component {
  constructor(props) {
		super(props);
    this.state = {
      visible: false,
      data: []
    }
  }

  componentDidMount() {
    const query = {
      unseen: 1,
    };
		this.props.getNotifications(query);
	}

  checkNotification(id) {
    this.props.checkNotification(id, () => {
      const query = {
        unseen: 1,
      };
      this.props.getNotifications(query);
    })
  }

  redirection(notification) {
    if (notification.requestTranslation) {
      return `/app/requests/request-translation/edit-request/${notification.requestTranslation.id}`
    } else return "/app/requests/request-translation/list"
  }

  getNotificationBody = (list) => {
    return list.length > 0 ?
    <List
      size="small"
      itemLayout="horizontal"
      dataSource={list}
      renderItem={item => (
        <List.Item className="list-clickable">
          <Link to={this.redirection(item)}>
            <Flex alignItems="center">
              <div className="pr-3" style={{width: '20%'}}>
                {item.img ? <Avatar src={`/img/avatars/${item.img}`} /> : <Avatar className={`ant-avatar-${item.type}`} icon={getIcon(item.icon)} />}
              </div>
              <div className="mr-3" style={{width: '45%'}}>
                <span className="font-weight-bold text-dark">{item.user} </span>
                <span className="text-gray-light">{item.message}</span>
              </div>
              <small className="mr-3" style={{width: '25%'}}>{moment(item.date).format('DD/MM/YYYY  hh:mm')}</small>
              {!item.read ? <small className="ml-auto" onClick={() => this.checkNotification(item.id)} style={{width: '5%'}}>
                <EyeOutlined/> 
              </small> : null}
            </Flex>
          </Link>
        </List.Item>
      )}
    />
    :
    <div className="empty-notification">
      <img src="https://gw.alipayobjects.com/zos/rmsportal/sAuJeJzSKbUmHfBQRzmZ.svg" alt="empty" />
      <p className="mt-3">You have viewed all notifications</p>
    </div>;
  }

  componentDidUpdate(prevProps) {
    if (prevProps.notifications.length !== this.props.notifications.length) {
      this.setState({
        data: this.props.notifications
      })
    }
  }

  handleVisibleChange = (flag) => {
    this.setState({
			visible: flag
		});
  }

  clearAll = () => {
    this.props.checkAllNotifications(() => {
      const query = {
        unseen: 1,
      };
      this.props.getNotifications(query);
    })
  }

  render() {
    const { visible, data } = this.state;

    return (
      <Dropdown 
        placement="bottomRight"
        overlay={() => (
          <div className="nav-dropdown nav-notification">
            <div className="nav-notification-header d-flex justify-content-between align-items-center">
              <h4 className="mb-0">Notification</h4>
              <Button className="text-primary" type="text" onClick={() => this.clearAll()} size="small">Clear </Button>
            </div>
            <div className="nav-notification-body">
              {this.getNotificationBody(data)}
            </div>
            <div className="nav-notification-footer">
              <Link to="/app/settings/notifications/list">
                <Button className="text-primary" type="text" size="small">View all</Button>
              </Link>
            </div>
          </div>
        )}
        onVisibleChange={(flag) => this.handleVisibleChange(flag)}
        visible={visible}
        trigger={['click']}
      >
        <Menu mode="horizontal">
          <Menu.Item key="notification">
            <Badge count={this.props.count_unseen}>
              <BellOutlined className="nav-icon mx-auto" type="bell" />
            </Badge>
          </Menu.Item>
        </Menu>
      </Dropdown>
    )
  }
}

const mapStateToProps = ({ notification }) => {
  const { loading, message, notifications, count, count_unseen} =  notification;

  return { 
    loading,
    message,
    notifications,
    count,
    count_unseen
  }
};

export default connect(
  mapStateToProps, {
    getNotifications,
    checkNotification,
    checkAllNotifications
  })(NavNotification);
